import React, { useState } from 'react';
import { Search, Package } from 'lucide-react';
import { Input } from '@/components/ui/input';
import LiquidacionDetailCard from './LiquidacionDetailCard';
import LiquidacionPreviewDetailDialog from './LiquidacionPreviewDetailDialog';

/**
 * Lista de entregas de una liquidación ya creada (modo detalle).
 * Mismo patrón visual que LiquidacionPreviewList, pero sin checkboxes
 * (todas las entregas ya están incluidas en la liquidación).
 *
 * Props:
 *  - entregas: array de entregas
 *  - editable: bool, si la liquidación está en Borrador
 *  - onPrecioChange(entregaId, prendaId, value) -> Promise
 *  - savingKey
 */
const LiquidacionDetailList = ({ entregas, editable, onPrecioChange, savingKey }) => {
  const [openEntrega, setOpenEntrega] = useState(null);
  const [search, setSearch] = useState('');

  const sorted = [...(entregas || [])].sort(
    (a, b) => new Date(b.fechaEntrega) - new Date(a.fechaEntrega),
  );

  const filtered = (() => {
    if (!search.trim()) return sorted;
    const term = search.toLowerCase();
    return sorted.filter((e) => {
      return (
        (e.consecutivo || '').toLowerCase().includes(term) ||
        (e.lavanderia?.nombre || '').toLowerCase().includes(term)
      );
    });
  })();

  return (
    <>
      <div className="relative flex-1 mb-3">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
        <Input
          placeholder="Buscar por consecutivo o lavandería..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="pl-10 h-9 text-sm"
        />
      </div>

      {filtered.length === 0 ? (
        <div className="text-center py-10 bg-gray-50 rounded-lg border border-dashed">
          <Package className="h-10 w-10 text-gray-300 mx-auto mb-2" />
          <p className="text-sm text-gray-500">Sin entregas que coincidan con el filtro.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {filtered.map((e) => (
            <LiquidacionDetailCard
              key={e.entregaId}
              entrega={e}
              editable={editable}
              onOpenDetail={setOpenEntrega}
            />
          ))}
        </div>
      )}

      {editable && (
        <LiquidacionPreviewDetailDialog
          entrega={openEntrega}
          onClose={() => setOpenEntrega(null)}
          onPrecioChange={onPrecioChange}
          savingKey={savingKey}
        />
      )}
    </>
  );
};

export default LiquidacionDetailList;
